import { DevicePlatform } from '@/types/devicePlatform'

export const DEVICE_PLATFORM_KIND = {
  PLATFORMS: 'PLATFORMS',
  BROWSERS: 'BROWSERS',
  DEVICES: 'DEVICES'
} as const

export const DEVICE_PLATFORMS: DevicePlatform[] = [
  {
    name: 'Ios',
    value: 'ios',
    kind: DEVICE_PLATFORM_KIND.PLATFORMS
  },
  {
    name: 'Android',
    value: 'android',
    kind: DEVICE_PLATFORM_KIND.PLATFORMS
  },
  {
    name: 'Other',
    value: 'other',
    kind: DEVICE_PLATFORM_KIND.PLATFORMS
  },
  {
    name: 'Chrome',
    value: 'chrome',
    kind: DEVICE_PLATFORM_KIND.PLATFORMS
  },
  {
    name: 'Ie',
    value: 'ie',
    kind: DEVICE_PLATFORM_KIND.BROWSERS
  },
  {
    name: 'Firefox',
    value: 'firefox',
    kind: DEVICE_PLATFORM_KIND.BROWSERS
  },
  {
    name: 'Safari',
    value: 'safari',
    kind: DEVICE_PLATFORM_KIND.BROWSERS
  },
  {
    name: 'Mobile',
    value: 'mobile',
    kind: DEVICE_PLATFORM_KIND.DEVICES
  },
  {
    name: 'Desktop',
    value: 'desktop',
    kind: DEVICE_PLATFORM_KIND.DEVICES
  }
]
